import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {RestResult} from '../models/response/rest-result';
import {Path} from '../common/path';
import {CommonService} from './common.service';

@Injectable()
export class FileService {
  constructor(private http: HttpClient,
              private commonService: CommonService) {
  }

  uploadFile(file: File): Observable<RestResult> {
    const form = new FormData();
    form.append('file', file);
    const url = Path.API_ENDPOINT + Path.FILE + Path.UPLOAD;
    return this.http.post<any>(url, form).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }
}
